import parseISO from "date-fns/parseISO"
import formatDate from "date-fns/format"

export default (date, format) =>
  date ? formatDate(parseISO(date), format) : null
